import React from 'react';
import FirmwareState from './firmwareState/FirmwareState';
import FirmwareControlPanel from './components/FirmwareControlPanel/FirmwareControlPanel';
import Firmware from './components/Firmware/Firmware';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const FirmwarePage: React.FC = () => {
	return (
		<FirmwareState>
			<div className={style.container} data-test="FirmwarePage">
				<FirmwareControlPanel />
				<Firmware />
				<ModalWindows />
			</div>
		</FirmwareState>
	);
};

export default FirmwarePage;
